import { Currency } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    currencies: Currency[]
    getCurrency: (alpha: string) => Currency
    getCurrencyName: (id: string) => string
}

export default function useCurrencies(): ReturnProps {
    const { i18n } = useTranslation()
    const { entities, loaded } = useGlobalContext('currencies')

    const currencies: Currency[] = useMemo(() => entities?.sort((a, b) => (a.position || 1000) - (b.position || 1000)) || [], [entities])

    const getCurrency = (alpha: string) => currencies.find(value => value.alpha === alpha)
    const getCurrencyName = (id: string) =>
        getI18NName(
            currencies.find(value => value.alpha === id),
            i18n.language,
        )

    return { loaded, currencies, getCurrency, getCurrencyName }
}
